import styles from './date-time-picker.module.scss';
import { DateTimePicker as MaterialDateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { StaticDateTimePicker as MaterialStaticDateTimePicker } from '@mui/x-date-pickers/StaticDateTimePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import nb from "date-fns/locale/nb";

/* eslint-disable-next-line */
export interface DateTimePickerProps {
  onChange: (event: any) => void,
  renderInput: any,
  // acceptRegex?: any,
  // allowSameDateSelection?: boolean,
  // ampm?: boolean,
  // ampmInClock?: boolean,
  // cancelText?: ReactNode,
  // className?: string,
  // clearable?: boolean,
  // clearText?: ReactNode,
  // components?: {
  //   LeftArrowButton?: any,
  //   LeftArrowIcon?: any,
  //   OpenPickerIcon?: any,
  //   RightArrowButton?: any,
  //   RightArrowIcon?: any,
  //   SwitchViewButton?: any,
  //   SwitchViewIcon?: any
  // },
  // componentsProps?: {
  //   leftArrowButton?: object,
  //   rightArrowButton?: object,
  //   switchViewButton?: object
  // },
  // dateRangeIcon?: ReactNode,
  // defaultCalendarMonth?: any,
  // desktopModeMediaQuery?: string,
  // DialogProps?: object,
  // disableCloseOnSelect?: boolean,
  // disabled?: boolean,
  // disableHighlightToday?: boolean,
  // disableIgnoringDatePartForTimeValidation?: boolean,
  // disableMaskedInput?: boolean,
  // disableOpenPicker?: boolean,
  // getClockLabelText?: any,
  // getOpenDialogAriaText?: any,
  // getViewSwitchingButtonText?: () => void,
  // hideTabs?: boolean,
  // InputAdornmentProps?: object,
  inputFormat?: string,
  // inputRef?: any,
  // leftArrowButtonText?: string,
  // loading?: boolean,
  mask?: string,
  // maxDate?: any,
  // maxDateTime?: any,
  // maxTime?: any,
  // minDate?: any,
  // minDateTime?: any,
  // minTime?: any,
  // minutesStep?: number,
  // okText?: ReactNode,
  // onAccept?: () => void,
  // onClose?: () => void,
  // onError?: () => void,
  // onMonthChange?: () => void,
  // onOpen?: () => void,
  // onViewChange?: () => void,
  // onYearChange?: () => void,
  open?: boolean,
  // OpenPickerButtonProps?: object,
  // openTo?: 'day' | 'hours' | 'minutes' | 'month' | 'seconds' | 'year',
  // orientation?: 'landscape' | 'portrait',
  // PaperProps?: object,
  // PopperProps?: object,
  // readOnly?: boolean,
  // reduceAnimations?: boolean,
  // renderDay?: () => void,
  // renderLoading?: () => void,
  // rifmFormatter?: () => void,
  // rightArrowButtonText?: string,
  // shouldDisableDate?: () => void,
  // shouldDisableTime?: () => void,
  // shouldDisableYear?: () => void,
  // showDaysOutsideCurrentMonth?: boolean,
  // showTodayButton?: boolean,
  // showToolbar?: boolean,
  // timeIcon?: ReactNode,
  // todayText?: ReactNode,
  // ToolbarComponent?: any,
  // toolbarFormat?: string,
  // toolbarPlaceholder?: ReactNode,
  // toolbarTitle?: ReactNode,
  // TransitionComponent?: any,
  value?: any | Date | number | string,
  // views?: Array<'day' | 'hours' | 'minutes' | 'month' | 'seconds' | 'year'>,
  label?: string
}

export interface StaticDateTimePickerProps {
  onChange: (event: any) => void,
  renderInput: any,
  // acceptRegex?: any,
  // allowSameDateSelection?: boolean,
  // ampm?: boolean,
  // ampmInClock?: boolean,
  // className?: string,
  // components?: {
  //   LeftArrowButton?: any,
  //   LeftArrowIcon?: any,
  //   OpenPickerIcon?: any,
  //   RightArrowButton?: any,
  //   RightArrowIcon?: any,
  //   SwitchViewButton?: any,
  //   SwitchViewIcon?: any
  // },
  // componentsProps?: object,
  // dateRangeIcon?: ReactNode,
  // defaultCalendarMonth?: any,
  // disableCloseOnSelect?: boolean,
  // disabled?: boolean,
  // disableHighlightToday?: boolean,
  // disableIgnoringDatePartForTimeValidation?: boolean,
  // disableMaskedInput?: boolean,
  // disableOpenPicker?: boolean,
  displayStaticWrapperAs?: 'desktop' | 'mobile',
  // getClockLabelText?: () => void,
  // getOpenDialogAriaText?: () => void,
  // getViewSwitchingButtonText?: () => void,
  // hideTabs?: boolean,
  // InputAdornmentProps?: object,
  // inputFormat?: string,
  // inputRef?: any,
  // leftArrowButtonText?: string,
  // loading?: boolean,
  // mask?: string,
  // maxDate?: any,
  // maxDateTime?: any,
  // maxTime?: any,
  // minDate?: any,
  // minDateTime?: any,
  // minTime?: any,
  // minutesStep?: number,
  // onAccept?: () => void,
  // onClose?: () => void,
  // onError?: () => void,
  // onMonthChange?: () => void,
  // onOpen?: () => void,
  // onViewChange?: () => void,
  // onYearChange?: () => void,
  // open?: boolean,
  // OpenPickerButtonProps?: object,
  openTo?: 'day' | 'hours' | 'minutes' | 'month' | 'seconds' | 'year',
  // orientation?: 'landscape' | 'portrait',
  // readOnly?: boolean,
  // reduceAnimations?: boolean,
  // renderDay?: () => void,
  // renderLoading?: () => void,
  // rifmFormatter?: () => void,
  // rightArrowButtonText?: string,
  // shouldDisableDate?: () => void,
  // shouldDisableTime?: () => void,
  // shouldDisableYear?: () => void,
  // showDaysOutsideCurrentMonth?: boolean,
  // showToolbar?: boolean,
  // timeIcon?: ReactNode,
  // ToolbarComponent?: any,
  // toolbarFormat?: string,
  // toolbarPlaceholder?: ReactNode,
  // toolbarTitle?: ReactNode,
  value?: any | Date | number | string,
  // views?: Array<'day' | 'hours' | 'minutes' | 'month' | 'seconds' | 'year'>
}

export function DateTimePicker(props: DateTimePickerProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={nb}>
      <MaterialDateTimePicker
        renderInput={props.renderInput}
        value={props.value}
        onChange={props.onChange}
        inputFormat={props.inputFormat}
        mask={props.mask}
        label={props.label}
        open={props.open}
      />
    </LocalizationProvider>
  );
}

export function StaticDateTimePicker(props: StaticDateTimePickerProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={nb}>
      <MaterialStaticDateTimePicker
        displayStaticWrapperAs={props.displayStaticWrapperAs}
        openTo={props.openTo}
        value={props.value}
        onChange={props.onChange}
        renderInput={props.renderInput}
      />
    </LocalizationProvider>
  );
}

export default DateTimePicker;